const ITEMS = [
    "Implantologia completa",
    "Volo e hotel inclusi",
    "Preventivo gratuito in 24h",
    "Valona · Albania",
    "Transfer privato",
    "Team che parla italiano",
];

export const Marquee = () => (
    <div
        data-testid="marquee-strip"
        className="relative overflow-hidden border-y border-white/10 bg-charcoal py-6 sm:py-8"
    >
        <div className="animate-marquee flex w-max items-center">
            {[0, 1].map((copy) => (
                <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
                    {ITEMS.map((item) => (
                        <span
                            key={`${copy}-${item}`}
                            className="font-display italic text-2xl sm:text-4xl text-white/20 whitespace-nowrap px-6"
                        >
                            {item}
                            <span className="text-gold/50 not-italic pl-12">✦</span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
